"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.tooltip");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellContainer = function CellContainer(props) {
  var children = props.children,
      height = props.height,
      type = props.type,
      header = props.header,
      headerText = props.headerText,
      handleClick = props.handleClick,
      highlighted = props.highlighted,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      sorted = props.sorted;
  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    width: width,
    onClick: handleClick,
    fontSize: 0,
    sortable: sortable,
    sortOrder: sortOrder,
    sorted: sorted
  }, headerText, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents.TooltipWithIcon, {
    iconSize: "small",
    type: props.type
  })) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    height: height,
    highlighted: highlighted,
    width: width,
    fontSize: 2,
    type: type,
    sorted: sorted
  }, /*#__PURE__*/_react["default"].createElement(_styled.CellTextBox, null, children));
};

var _default = CellContainer;
exports["default"] = _default;

//# sourceMappingURL=CellContainer.js.map